import { reducer as eventsEmbed } from "lib/api/events";
import { combineReducers } from "redux";

export const rootReducer = combineReducers({
  eventsEmbed,
});
